import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCliente } from "../context/ClienteContext";
import axios from "axios";
import "../styles/CadastroUsuario.css";
import "../styles/global.css";

const ListagemTurmas = () => {
  const navigate = useNavigate();
  const { parametros } = useCliente();

  const [turmas, setTurmas] = useState([]);
  const [filtroCodigo, setFiltroCodigo] = useState("");
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroCurso, setFiltroCurso] = useState("");
  const [cursos, setCursos] = useState([]);


  
  useEffect(() => {
    const fetchTurmasECursos = async () => {
      try {
        const clienteId = localStorage.getItem("cliente_id");
        const tipo = localStorage.getItem("tipo");
        const userId = localStorage.getItem("user_id");
  
        const [turmasResponse, cursosResponse] = await Promise.all([
          axios.get("/api/turmas", {
            params: {
              cliente_id: clienteId,
              tipo: tipo,
              user_id: userId
            }
          }),
          axios.get(`/api/cursos?cliente_id=${clienteId}`)
        ]);
  
        if (Array.isArray(turmasResponse.data)) {
          setTurmas(turmasResponse.data);
        }
        if (Array.isArray(cursosResponse.data)) {
          setCursos(cursosResponse.data);
        }
      } catch (error) {
        console.error("Erro ao carregar turmas ou cursos:", error);
      }
    };
  
    fetchTurmasECursos();
  }, []);
  

  const limparFiltros = () => {
    setFiltroCodigo("");
    setFiltroNome("");
    setFiltroCurso("");
  };

  const buscarNomeCurso = (cursoId) => {
    const cursoEncontrado = cursos.find(curso => curso.id === cursoId);
    return cursoEncontrado ? cursoEncontrado.nome : "";
  };

  const turmasFiltradas = turmas.filter(turma => {
    const codigoOk = turma.codigo?.toLowerCase().includes(filtroCodigo.toLowerCase());
    const nomeOk = turma.nome?.toLowerCase().includes(filtroNome.toLowerCase());
    const cursoOk = filtroCurso ? turma.curso_id === parseInt(filtroCurso) : true;
    return codigoOk && nomeOk && cursoOk;
  });

  const irParaDetalhesTurma = (id) => {
    navigate(`/detalhes-turma/${id}`);
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">
        {["coordenador", "professor"].includes(localStorage.getItem("tipo"))
          ? "Minhas Turmas"
          : "Listagem de Turmas"}
       </h2>

      {/* Filtros */}
      <div className="filtros-cursos">
        <div className="filtros-linha-1">
          <input
            type="text"
            value={filtroCodigo}
            onChange={(e) => setFiltroCodigo(e.target.value)}
            placeholder="Filtrar Código"
            style={{ width: "120px" }}
          />
          <input
            type="text"
            value={filtroNome}
            onChange={(e) => setFiltroNome(e.target.value)}
            placeholder="Filtrar Nome"
          />
          <select
            value={filtroCurso}
            onChange={(e) => setFiltroCurso(e.target.value)}
          >
            <option value="">Filtrar Curso</option>
            {cursos.map(curso => (
              <option key={curso.id} value={curso.id}>
                {curso.nome}
              </option>
            ))}
          </select>
          <button className="btn btn-secondary" onClick={limparFiltros}>
            Limpar Filtros
          </button>
          {!["coordenador", "professor"].includes(localStorage.getItem("tipo")) && (
          <button
            className="btn btn-primary"
            onClick={() => navigate("/cadastro-turma")}
          >
            Adicionar Turma
          </button>
)}

        </div>
      </div>

      {/* Tabela */}
      <div className="table-wrapper">
        <table className="tabela">
          <thead style={{ backgroundColor: parametros?.cor_cabecalho || "#156082", color: "white" }}>
            <tr>
              <th style={{ width: "15%" }}>Código</th>
              <th style={{ width: "30%" }}>Nome da Turma</th>
              <th style={{ width: "25%" }}>Curso</th>
              <th style={{ width: "15%" }}>Início</th>
              <th style={{ width: "15%" }}>Término</th>
            </tr>
          </thead>
          <tbody>
            {turmasFiltradas.map(turma => (
              <tr
                key={turma.id}
                onClick={() => irParaDetalhesTurma(turma.id)}
                style={{ cursor: "pointer" }}
              >
                <td>{turma.codigo}</td>
                <td style={{ color: "#007bff", textDecoration: "underline" }}> {turma.nome}</td>
                <td>{buscarNomeCurso(turma.curso_id)}</td>
                <td>{turma.data_inicio}</td>
                <td>{turma.data_termino}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListagemTurmas;
